<template>
  <b-form-group
    :label="label"
    :label-class="{ required }"
    :invalid-feedback="error"
    :state="error ? false : null">
    <code-input-field
      v-bind="$props"
      @input="$emit('input', $event)"
    />
  </b-form-group>
</template>
<script>
import FormFieldMixin from 'vue-forms/mixins/FormFieldMixin';
import CodeFieldMixin from 'vue-forms/mixins/CodeFieldMixin';

export default {
  mixins: [ FormFieldMixin, CodeFieldMixin ],
};
</script>
